import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINES = [
  "Weighing your answers…",
  "Consulting the ancients…",
  "Comparing 20 centuries of thought…",
];

export default function Computing({ onDone }) {
  const [lineIdx, setLineIdx] = useState(0);

  useEffect(() => {
    const t1 = window.setTimeout(() => setLineIdx(1), 720);
    const t2 = window.setTimeout(() => setLineIdx(2), 1440);
    const t3 = window.setTimeout(() => onDone(), 2200);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [onDone]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      className="relative z-10 flex min-h-[100dvh] flex-col items-center justify-center px-6"
      data-testid="computing-screen"
    >
      <div className="relative flex h-40 w-40 items-center justify-center">
        <div className="pulse-ring" style={{ width: 160, height: 160 }} />
        <div
          className="pulse-ring"
          style={{ width: 160, height: 160, animationDelay: "700ms" }}
        />
        <div
          className="pulse-core h-14 w-14 rounded-full"
          style={{
            background:
              "radial-gradient(circle, var(--gold-light) 0%, var(--gold) 55%, rgba(201,167,85,0.4) 100%)",
          }}
        />
      </div>

      <div className="mt-14 h-6 w-full max-w-xs text-center">
        <motion.p
          key={lineIdx}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="font-serif italic text-sm sm:text-base"
          style={{ color: "var(--gold-light)", letterSpacing: "0.02em" }}
          data-testid="computing-line"
        >
          {LINES[lineIdx]}
        </motion.p>
      </div>
    </motion.div>
  );
}
